module.exports = __webpack_public_path__ + "img/202412_skinwash.5cfdc133.jpg";